import { Trans } from '@lingui/react/macro';
import { Button } from '@pantry/ui';
import { ShoppingCartIcon } from 'lucide-react';

interface EmptyStateProps {
  variant: 'no-lists' | 'no-archived' | 'no-items';
  onCreateList?: () => void;
}

/**
 * Empty state component for shopping lists overview and detail pages.
 */
export function EmptyState({ variant, onCreateList }: EmptyStateProps) {
  if (variant === 'no-archived') {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <p className="text-muted-foreground">
          <Trans>No archived lists</Trans>
        </p>
      </div>
    );
  }

  if (variant === 'no-items') {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <div className="mx-auto w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-3">
          <ShoppingCartIcon className="h-6 w-6 text-muted-foreground" />
        </div>
        <p className="font-medium text-foreground">
          <Trans>No items yet</Trans>
        </p>
        <p className="text-sm text-muted-foreground mt-1">
          <Trans>Add an item using the form above.</Trans>
        </p>
      </div>
    );
  }

  // no-lists
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="mx-auto w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center mb-6">
        <ShoppingCartIcon className="h-10 w-10 text-primary" />
      </div>
      <h2 className="font-display text-2xl font-semibold text-foreground mb-2">
        <Trans>No shopping lists yet</Trans>
      </h2>
      <p className="text-muted-foreground mb-6 max-w-xs">
        <Trans>Create your first shopping list to start planning your grocery runs.</Trans>
      </p>
      {onCreateList && (
        <Button onClick={onCreateList}>
          <Trans context="action_button">Create your first shopping list</Trans>
        </Button>
      )}
    </div>
  );
}
